
export class AkmeDataPartition {
collection: string;
engineCode: string;
property: string;
}

